export const formatTime = (theTime) => {
  const hours = theTime.split(':')[0];
  const minutes = theTime.split(':')[1];
  if (hours > 12) {
    return `${hours - 12}:${minutes}pm`;
  } else if (hours === '00') {
    return `12:${minutes}am`;
  } else if (hours === '12') {
    return `${hours}:${minutes}pm`;
  } else {
    return `${hours}:${minutes}am`;
  }
};

export const timeTrim = (startTime, endTime) => {
  if (startTime && endTime) {
    if (startTime.slice(-2) === endTime.slice(-2)) {
      return `${startTime.slice(0, -2)}-${endTime}`;
    } else {
      return `${startTime}-${endTime}`;
    }
  }
  return 'Invalid Time';
};
